<template lang="html">
  <main>
    <PageHeader page-title="Your Booking" />
    <SectionTable v-if="myBooking" :table-group="myBooking"></SectionTable>
    <PageFooter />
  </main>
</template>

<script>
import Booking from '@/dummy/booking.json'
import PageFooter from '@/components/page-footer/PageFooter.vue'
import Header from '@/components/heading/Heading'
import PageHeader from '@/sections/page-header/PageHeader'
import SectionTable from '@/sections/section-table/SectionTable.vue'
import Button from '@/components/partials/Button'
import { EVENTS, EventBus } from '@/services/events/EventBus'
import HttpUnAuthenticatedError from '@/objects/Exceptions/HttpUnAuthenticatedError'

import ContentGenerator from '@/sections/content-generator/ContentGenerator.vue'

import MeService from '@/services/MeService'
import HttpError from '@/objects/Exceptions/HttpError'

export default {
  name: 'Settings',
  components: {
    PageFooter,
    Header,
    PageHeader,
    SectionTable
  },
  data() {
    return {
      data: Booking
    }
  },
  computed: {
    bookings () {
      return this.$store.state.reservations
    },
    myBooking () {
      const myBooking = this.$store.state.reservations.reservations.find(r => r.externalId === this.$route.params.bookingId)
      console.log('myBooking: ', myBooking)
      if (!myBooking) {
        return null
      }
      return [{
        title: 'My Booking',
        links: [
          {
            title: 'Hotel',
            value: 'THIS HOTEL'
          },
          {
            title: 'Total guests',
            value: myBooking.totalAdults + myBooking.totalChildren
          },
          {
            title: 'Nr. of Nights',
            value: myBooking.numberOfNights
          },
          {
            title: 'Check in',
            value: myBooking.checkInDate
          },
          {
            title: 'Check out',
            value: myBooking.checkOutDate
          },
          // {
          //   title: 'Nr. of Nights',
          //   value: myBooking.numberOfNights
          // },
          // {
          //   title: 'Nr. of Nights',
          //   value: myBooking.numberOfNights
          // },

        ]
      }]
    }
  },
  methods: {
    fetchBookings () {
      this.$store.dispatch('reservations/getReservations')
    },
    fetchBooking(bookingId) {
      MeService.getBooking(bookingId)
        .then((response) => {
          if (response.status == 'failed') {
            throw HttpError.parseError(response.message)
          } else {
            console.log('Booking detail....', response)
          }
        }).catch((error) => {
          throw HttpError.parseError(error)
        })
    }
  },
  mounted () {
    this.fetchBookings()
    this.fetchBooking(this.$route.params.bookingId)
  }
}
</script>
